import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.performanceWfuhs',
    'package:data.universal.orgStructure.withoutDivisions',
    'resource:data.dimensions.organization.entities.subdepartment',
    'resource:data.dimensions.organization.entities.subdepartment.attributes.shouldAnalyze',
    'resource:solutions.apps.rpWfuhs.pages.explore',
    'resource:solutions.apps.rpWfuhs.pages.overview',
    'resource:solutions.apps.rpWfuhs.pages.trends',
    'resource:solutions.apps.rpWfuhs',
    'resource:solutions.mosaic.pages.rpWfuhs.exploreUpdatedOrgStructure',
    'resource:solutions.mosaic.pages.rpWfuhs.overviewWithPiScatter',
    'resource:solutions.mosaic.pages.rpWfuhs.trendsUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.exploreMetricsUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.explorePerfComparison',
    'resource:solutions.mosaic.widgets.rpWfuhs.exploreTrendsUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.orgTableUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.overviewDonutUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.overviewMetricsUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.overviewTrends',
    'resource:solutions.mosaic.widgets.rpWfuhs.piScatterUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.piTableUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.projectsTableUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.spaceTableUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.sponsorsTableUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.trendsStackedUpdatedOrgStructure',
    'resource:solutions.mosaic.widgets.rpWfuhs.trendsTableUpdatedOrgStructure',
  ],
  description: 'Standard Research Performance',
  name: 'RP',
} as const satisfies core.quiver.Package
